/**
 * Enum for Wolt Package Api.
 * @readonly
 * @enum {String} WoltPackageApiEnum
 */

const WoltPackageApiEnum = {
  BASIC        : 'WOLT_BASIC',
  ADVANCED     : 'WOLT_ADVANCED',
  IPAD_FREE    : 'WOLT_IPAD_FREE',
  SELF_DELIVERY: 'WOLT_SELF_DELIVERY'
}

export default WoltPackageApiEnum
